import React from 'react';
import { SmartQuestionRenderer } from 'components/stepper/field-components/QuestionnaireField';
import { GetQuestionnaireOutput } from 'graphql/generated/remote-schema-hasura';
import { useQuestionnaireSections } from 'components/questionnaire/hooks/useQuestionnaire';
import { DynamicQuestionnaireDependencie } from 'components/dynamicQuestionnaire/interfaces/dynamicQuestionnaireResponse.interface';
import FieldLabel from 'components/stepper/field-components/FieldLabel';
import { useGetDynamicDeps } from 'components/stepper/useStepperForm';
import {
  AllergensQuestionnaireField,
  MedAllergensQuestionnaireField,
} from '../../../../../health-questionnaire/forms/AllergenField';
import AdditionalInformation from '../../../../../health-questionnaire/forms/AdditionalInformation';
import {
  ADDITIONAL_CHILD_INFORMATION_ID,
  MED_ALLERGENS_ID,
} from '../useChildQuestionaireValidations';

interface GeneralInfoProps {
  getQuestionnaireOutput: GetQuestionnaireOutput;
  sectionIndex: number;
}

const GeneralInfo: React.FC<GeneralInfoProps> = ({
  getQuestionnaireOutput,
  sectionIndex,
}) => {
  const { questionList, currentSection, questionsById } =
    useQuestionnaireSections(getQuestionnaireOutput, sectionIndex);

  const sectionDependencies = (currentSection?.dependencies ??
    []) as DynamicQuestionnaireDependencie[];

  const dynamicDeps = useGetDynamicDeps(sectionDependencies);

  if (!currentSection) {
    return null;
  }

  return (
    <>
      <FieldLabel
        name="general-info"
        label="Who is your child’s primary doctor? Please include their full name and how we can contact them"
      />
      <SmartQuestionRenderer
        questionList={questionList}
        dependencies={currentSection?.dependencies ?? []}
        questionsById={questionsById}
        dynamicDeps={dynamicDeps}
        customFields={{
          [MED_ALLERGENS_ID]: MedAllergensQuestionnaireField,
          '172': AllergensQuestionnaireField,
          [ADDITIONAL_CHILD_INFORMATION_ID]: AdditionalInformation,
        }}
      />
    </>
  );
};

export default GeneralInfo;
